import "../styles/Test.css";
import { ethers } from "ethers";
import contractArtifact from "../contracts/PromptMeister.json";
import React, { createContext, useContext, useState, useEffect } from "react";
function Test(){

    const functionOne = async () => {
        let provider = new ethers.JsonRpcProvider(contractArtifact.rpcUrl);
    let pm = new ethers.Contract(contractArtifact.address, contractArtifact.abi, provider)
    let test1 = await pm.getMintPrice();
    console.log(test1);
    }
    return(<div id="container">
        <p id="p-box">Bababooey</p>
        <button onClick={functionOne}>hello</button>
    </div>);
}
export default Test;